import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import { colors } from './colors.js';

var getColor = function getColor(color, theme) {
  if (colors[color] === undefined) {
    throw new Error("Color ".concat(color, " does not exist!"));
  }

  if (colors[color][theme] === undefined) {
    var _context;

    throw new Error(_concatInstanceProperty(_context = "Color ".concat(color, " does not have theme ")).call(_context, theme, "!"));
  }

  return colors[color][theme];
};

export { getColor };
//# sourceMappingURL=getColor.js.map
